import React from 'react';

import { Alert } from '@mui/material';

import type { ChatFailureKind } from './chatFailure';

export interface TurnFault {
  kind: ChatFailureKind | 'stopped' | 'cut-off';
  message: string;
  action?: React.ReactNode;
}

export default function TurnFaultAlert({ fault }: { fault: TurnFault }) {
  return (
    <Alert
      data-testid="ui-stream-turn-fault"
      data-fault={fault.kind}
      severity={fault.kind === 'stopped' ? 'info' : 'warning'}
      sx={{ mt: 1.5, borderRadius: 1, alignItems: 'center' }}
      action={fault.action}
    >
      {fault.message}
    </Alert>
  );
}
